var LoadingButton = require("components/utility/LoadingButton");
var Activity = require("components/writing/activities/Activity");
var TeacherPreviewNotice = require("components/utility/TeacherPreviewNotice");
var Spinner = require("components/utility/Spinner");
var Glyphicon = require("components/utility/icons/Glyphicon");
var Autosaver = require("components/writing/quizzes/Autosaver");
var NameModal = require("components/writing/responses/NameModal");
var AssignTaskModal = require("components/writing/tasks/AssignTaskModal");
var AssignExerciseDetailsModal = require("components/writing/activities/AssignExerciseDetailsModal.js");

var CurrentUser = require("lib/account/CurrentUser");
var TextTypes = require("lib/academic/TextTypes");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var Modal = require('components/utility/AltModal');
var MyShelfRouting = require("lib/routing/MyShelfRouting");

require("writing/responses/new_response_page.scss");

class ResponseComposer extends React.Component{
	constructor(props) {
		super();
		autobind(this);
		this.assignTaskModal = React.createRef();
		this.assignExerciseDetailsModal = React.createRef();

		this.state = {
			activity: null, response: null,

			loading: false, autosaveLoading: false,
			selectedActivityTitle: "", selectedUserIDs: [],

			// Both used by passphrase activities
			name: null, savedResponseData: null
		};
	}

	submitResponse(responseData) {
		if (this.props.requireName) {
			if (this.state.name == null) {
				// Get the student to enter their name
				this.refs.nameModal.show();
				this.setState({ savedResponseData: responseData });
				return;

			} else {
				// Add in the name to the response data
				this.refs.nameModal.hide();
				var responseData = _.clone(responseData);
				var inputData = _.clone(responseData.input_data);
				inputData["__wr_name"] = this.state.name;
				responseData.input_data = inputData;
			}
		}

		// We're going to mutate this, so let's try to avoid mutating the parameter
		// NOTE: This is a shallow clone
		responseData = _.clone(responseData);
		responseData["minute_count"] = this.getMinuteCount();
		responseData["draft"] = false;

		// if edit mode
		if (this.hasDraft()) {
			responseData["edited_at"] = true;
		}
		if (!this.state.loading) {
			this.setState({ loading: true });
			if (this.state.response == null) {
				this.handleComplexInputs(responseData, function() {
					this.postResponse(responseData, function(serverResponse) {
						this.completionAction(serverResponse)
					}.bind(this));
				}.bind(this));
			} else {
				this.handleComplexInputs(responseData, function() {
					this.patchResponse(responseData, function(serverResponse) {
						this.completionAction(serverResponse)
					}.bind(this));
				}.bind(this));
			}
		}
	}

	deleteDraft() {
		if (this.state.response == null) {
			return;
		}
		CurrentUser.api().deleteResponse(this.state.response.id, $wr.apiHandler(function(serverResponse) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Your draft has been deleted!", text: "", icon: "trash" });

			$wr.redirect("/");

		}.bind(this)));
	}

	autosaveResponse(callback) {
		var responseData = _.clone(this.refs.activity.getAutosaveData());
		responseData["minute_count"] = this.getMinuteCount();
		responseData["draft"] = true;

		var activity_id = this.props.activityID;

		this.setState({ autosaveLoading: true });

		if (this.state.response == null) {
			var data = { response: responseData, activity_id: activity_id };
			this.postResponse(responseData, function(serverResponse) {
				this.setState({ response: serverResponse.response, autosaveLoading: false });
				if (callback) { callback() }
			}.bind(this));

		} else {
			this.patchResponse(responseData, function(serverResponse) {
				this.setState({ autosaveLoading: false });
				if (callback) { callback() }
			}.bind(this));
		}
	}

	onNameEntry(name) {
		this.setState({ name: name }, function() {
			this.submitResponse(this.state.savedResponseData);
		}.bind(this));
	}

	handleComplexInputs(responseData, callback) {
		var blobMap = {};
		_.each(responseData.input_data, function(value, key) {
			if (value instanceof Blob) {
				blobMap[key] = value;
			}
		});

		if (_.size(blobMap) > 0) {
			this.uploadFiles(blobMap, function(referenceMap) {
				// Replace all the blobs with a reference to the uploaded file
				_.each(referenceMap, function(reference, key) {
					responseData.input_data[key] = reference;
				});

				callback();
			}.bind(this))
		} else {
			callback();
		}
	}

	printActivity(e) {
		$wr.nope(e)
		var activity = this.state.activity;

		Mycroft.newEvent({ category: "Printables", action: "view-activitiy-onpage", label: activity.key });
		if (activity.format_summary) {
			setTimeout(function() {
				Mycroft.newEvent({ category: "Printables", action: "view-skillset-onpage", label: activity.format_summary.skillset });
			}, 1100);
			setTimeout(function() {
				Mycroft.newEvent({ category: "Printables", action: "view-format-onpage", label: activity.format_summary.format_class });
			}, 2200);
		}

		window.open(activity.thumbnail.printable_url, "_blank");
	}

	postResponse(responseData, callback) {
		responseData = _.clone(responseData);
		if (this.props.book) {
			responseData.text_id = this.props.book.text_id;
			responseData.text_variety = this.props.book.text_variety;
		}
		responseData.activity_id = this.props.activityID;

		CurrentUser.api().postResponses({ response: responseData }, $wr.apiHandler(function(serverResponse) {
			if (serverResponse.response.errors) {
				console.error(serverResponse.response.errors);
			} else if (callback) {
				callback(serverResponse);
			}
		}.bind(this)));
	}

	patchResponse(responseData, callback) {
		responseData = _.clone(responseData);
		if (this.props.book) {
			responseData.text_id = this.props.book.text_id;
		}

		CurrentUser.api().patchResponse(this.state.response.id, { response: responseData }, $wr.apiHandler(function(serverResponse) {
			if (serverResponse.response.errors) {
				console.error(serverResponse.response.errors);
			} else if (callback) {
				callback(serverResponse);
			}
		}.bind(this)));
	}

	completionAction(serverResponse) {
		if (this.state.activity.draft && !this.state.activity.draft.draft) {
			var text = "You edited: '" + this.state.activity.format.title + "'";
		} else {
			var text = "You completed: '" + this.state.activity.format.title + "'";
		}

		if (serverResponse.response.errors && serverResponse.response.errors.length > 0) {
			var errorText = serverResponse.response.errors.join("; ");
			window.wrNotifications.triggerDropDownNotification({
				title: "Something unexpected went wrong!", text: errorText, icon: "remove" }, 10000);

			return;
		} else {
			window.wrNotifications.triggerDropDownNotification({
				title: "Done!", text: text, icon: "star" });
		}

		CurrentUser.fetchCurrentUserCoinData();
		var mycroftAction = CurrentUser.isStudent() ? "complete" : "complete-preview";
		Mycroft.newEvent({ category: "Activity", action: mycroftAction, label: this.state.activity.key });

		// THIS WON'T RUN ANY MORE:
		// if (this.props.adminPreview && window.opener && window.opener.wr_openPreviewResposeModal) {
		// 	window.opener.wr_openPreviewResposeModal(serverResponse.response);
		if (this.props.adminPreview) {
			$wr.redirect("/");
		} else if (this.props.afterSubmit) {
			this.props.afterSubmit();
		} else {
			CurrentUser.fetchCurrentUserCoinData();
			if (!this.props.book.text_id || this.props.book.text_id === 'MISSING_TEXT_ID') {
				$wr.redirect(MyShelfRouting.getPath({
					activeView: MyShelfRouting.VIEWS.WORK_VIEW,
					detailsView: "exercises"
				}));
			} else if (this.props.book && this.props.book.text_id) {
				$wr.redirect(MyShelfRouting.getPath({
					activeView: MyShelfRouting.VIEWS.SHELF_VIEW,
					detailsView: "exercises",
					textID: this.props.book.text_id
				}));
			} else {
				var redirectPath = "/";
			}
			$wr.redirect(redirectPath);
		}
	}

	uploadFiles(blobMap, callback) {
		var referenceMap = {};
		var url = WhooosReadingServices.ApiServer.url("/file_uploads");

		_.each(blobMap, function(blob, key) {
			var fd = new FormData();
			fd.append("file_format", "wav");
			fd.append("data", blob);

			$.ajax({
				type: "POST", url: url, data: fd,
				processData: false, contentType: false
			}).done(function(serverResponse) {

				referenceMap[key] = serverResponse.upload_location;
				if (_.size(blobMap) == _.size(referenceMap)) {
					callback(referenceMap);
				}
			});
		});
	}

	hasDraft() {
		return this.state.response && this.state.response.draft;
	}

	onAssign() {
		if (this.props.adminPreview) {
			this.setState({ selectedActivityTitle: this.state.activity.format.title  }, () => {
				this.assignTaskModal.current.show()
			});
		}
	}

	hideAssignModal(selectedUserIDs, showNextModal) {
		showNextModal = showNextModal === null ? false : showNextModal;

		this.setState({ selectedUserIDs: selectedUserIDs })

		this.assignTaskModal.current.hide();
		if (showNextModal) {
			this.assignExerciseDetailsModal.current.show();
		}
	}

	renderAssignTaskModal() {
		if ($wr.getURLParameterByName("assign_student_ids")) {
			var assignStudentIDs = $wr.getURLParameterByName("assign_student_ids").split(",");
		}
		var modalHeader = "Assign " + this.state.selectedActivityTitle + " to:";
		return (
			<Modal headerText={ modalHeader } ref={ this.assignTaskModal } modalOrder={ 2 }>
				<AssignTaskModal key={ this.state.activity.id }
					selectedStudentIDs={assignStudentIDs}
					renderAdditionalModal={true}
					taskSubjectType="exercise" taskSubjectID={ this.state.activity.id }
					selectedActivityTitle={ this.state.selectedActivityTitle }
					onAssign={ this.hideAssignModal }
				/>
			</Modal>
		)
	}

	renderAssignExerciseDetailsModal() {
		var modalHeader = "Assign " + this.state.selectedActivityTitle + " to:";
		return (
			<Modal ref={this.assignExerciseDetailsModal} headerText={modalHeader} modalOrder={3}>
				<AssignExerciseDetailsModal
					selectedUserIDs={this.state.selectedUserIDs}
					taskSubjectType="Exercise"
					taskSubjectID={this.state.activity.id}
					selectedActivityTitle={this.state.selectedActivityTitle}
					onAssign={this.hideAssignExerciseDetailsModal} />
			</Modal>
		)
	}

	hideAssignExerciseDetailsModal() {
		this.assignExerciseDetailsModal.current.hide();
	}

	render() {
		if (this.state.activity == null || this.state.loading) {
			return (
				<div className="responseComposer">
					<Spinner placeholder={ true } scale={ 1.7 } />
				</div>
			);
		}

		if (this.props.adminPreview) {
			var assignButton = (
				<button className="btn buttonSuccess" onClick={ this.onAssign }>
					Assign
				</button>
			);

			var printOp = (
				<a className="printOp" href="#" onClick={ this.printActivity }>
					<Glyphicon icon="print"/> Print Exercise
				</a>
			);

			var previewNotice = (
				<TeacherPreviewNotice>
					{ assignButton }
					{ printOp }
				</TeacherPreviewNotice>
			);
			var assignModal = this.renderAssignTaskModal();
		}

		var textCompletion = this.state.activity.format.text_completion;

		if (this.props.requireName) {
			var nameModal = (
				<NameModal onNameEntry={ this.onNameEntry } ref="nameModal" />
			);
		}

		if (!CurrentUser.isAdmin()) {
			if (this.props.book) {
				var textID = this.props.book.text_id;
			}
			var autosaver = (
				<Autosaver onDeleteClick={ this.deleteDraft } textID={ textID }
					autosaveLoading={ this.state.loading || this.state.autosaveLoading }
					getAutosaveHash={ this.getAutosaveHash } onAutosave={ this.autosaveResponse } />
			);
		}

		return (
			<div className="responseComposer">
				{ nameModal }
				{ previewNotice }
				<Activity ref="activity" activity={ this.state.activity }
					response={ this.state.response }
					book={ this.props.book } onSubmit={ this.submitResponse } />

				{ autosaver }
				{ assignModal }
				{ this.renderAssignExerciseDetailsModal() }
			</div>
		);
	}

	getAutosaveHash() {
		if (this.refs && this.refs.activity) {
			return this.refs.activity.getAutosaveHash();
		}
	}

	getMinuteCount() {
		var diff = Math.round((new Date - this.state.startDate) / 60000)
		return this.state.previousMinuteCount + diff
	}

	pauseTimer() {
		this.setState({previousMinuteCount: this.getMinuteCount()})
	}

	resumeTimer() {
		this.setState({startDate: new Date})
	}

	initTimer() {
		window.actionPause = this.pauseTimer
		window.actionResume = this.resumeTimer
		$(window).blur(function(){
			if (window.actionPause) {
				window.actionPause()
			}
		});
		$(window).focus(function(){
			if (window.actionResume) {
				window.actionResume()
			}
		});
	}

	getActivity() {
		CurrentUser.api().getActivity(this.props.activityID, { embed: "activity.format" }, $wr.apiHandler(function(serverResponse) {
			var activity = serverResponse.activity;

			if (this.props.responseID) {
				var responseEmbeds = "response.activity,activity.format,response.input_data,response.activity_data,response.evaluation";
				CurrentUser.api().getResponse(this.props.responseID, { embed: responseEmbeds }, $wr.apiHandler(function(serverResponse) {
					this.setActivity(activity, serverResponse.response)
				}.bind(this)));

			} else {
				this.setActivity(activity, null);
			}
		}.bind(this)));
	}

	setActivity(activity, response) {
		var previousMinuteCount = 0;
		if (response) {
			previousMinuteCount = response.minute_count;
		}
		this.setState({ activity: activity, response: response,
			previousMinuteCount: previousMinuteCount, startDate: new Date() });

		var mycroftAction = CurrentUser.isStudent() ? "begin" : "begin-preview";
		Mycroft.newEvent({ category: "Activity", action: mycroftAction, label: activity.key });
		this.initTimer()
	}

	componentDidMount() {
		this.getActivity();
	}

	componentWillUnmount() {
		window.actionPause = null
		window.actionResume = null
	}

};

ResponseComposer.propTypes = StrictPropTypes({
	// ID of the activity to complete
	activityID: PropTypes.number.isRequired,

	// ID of the response draft to edit
	responseID: PropTypes.number,

	// Alternate behavior after the redirect
	afterSubmit: PropTypes.func,

	// Makes the student enter a name after completing the response
	requireName: PropTypes.bool,

	// Is an admin previewing the activity
	adminPreview: PropTypes.bool,

	// Book is optional (some don't have text_id)
	book: PropTypes.object,

	selectedStudentIDs: PropTypes.array
});

module.exports = ResponseComposer;



// WEBPACK FOOTER //
// ./modules/components/writing/responses/ResponseComposer.js